import { getOperationName } from 'apollo-link'

import {
  GetFeedsRecommendedDocument,
  GetGroupFollowersDocument,
  GetGroupListDocument,
  GetOnboardingRecomGroupsDocument,
  GetTrendingGroupsDocument,
  GetViewerFollowingGroupsDocument,
  GetViewerFollowingUsersDocument,
  GetViewerPinnedUsersDocument,
  useDepartmentBatchFollowMutation,
  useGroupBatchFollowMutation,
  useGroupFollowMutation,
  useGroupUnfollowMutation,
  useUserBatchFollowMutation,
  useUserFollowMutation,
  useUserUnfollowMutation,
} from '@/generated/graphql'

const onboardingRefetchQueries = [getOperationName(GetOnboardingRecomGroupsDocument)!]

const GroupRefetchQueries = [
  getOperationName(GetTrendingGroupsDocument)!,
  getOperationName(GetGroupFollowersDocument)!,
  getOperationName(GetViewerFollowingGroupsDocument)!,
  getOperationName(GetFeedsRecommendedDocument)!,
  getOperationName(GetGroupListDocument)!,
]

const UserRefetchQueries = [
  { query: GetViewerPinnedUsersDocument, variables: { pagination: { last: 8 } } },
  getOperationName(GetViewerFollowingUsersDocument)!,
  getOperationName(GetFeedsRecommendedDocument)!,
]

export const useFollow = ({
  followeeUserId,
  followeeGroupId,
  isOnboarding,
}: {
  followeeUserId?: number
  followeeGroupId?: number
  isOnboarding?: boolean
}) => {
  const [follow, { loading: loading1 }] = (followeeUserId ? useUserFollowMutation : useGroupFollowMutation)({
    refetchQueries: isOnboarding ? onboardingRefetchQueries : followeeUserId ? UserRefetchQueries : GroupRefetchQueries,
  })

  const [unfollow, { loading: loading2 }] = (followeeUserId ? useUserUnfollowMutation : useGroupUnfollowMutation)({
    refetchQueries: isOnboarding ? onboardingRefetchQueries : followeeUserId ? UserRefetchQueries : GroupRefetchQueries,
  })

  const variables = {
    followeeUserId: followeeUserId!,
    followeeGroupId: followeeGroupId!,
  }

  return {
    follow: () => follow({ variables }),
    unfollow: () => unfollow({ variables }),
    loading: loading1 || loading2,
  }
}

export const useFollowAll = ({
  followeeIds,
  target,
}: {
  followeeIds: number[]
  target: 'group' | 'user' | 'department'
}) => {
  const mutation = {
    group: useGroupBatchFollowMutation,
    department: useDepartmentBatchFollowMutation,
    user: useUserBatchFollowMutation,
  }[target]

  const followAllrefetchQueries = {
    group: [getOperationName(GetOnboardingRecomGroupsDocument)!],
    department: [getOperationName(GetViewerFollowingUsersDocument)!],
    user: [],
  }[target]

  const [batchFollow, { loading }] = mutation({ refetchQueries: followAllrefetchQueries })

  const variables = (() => {
    switch (target) {
      case 'group':
        return { followeeGroupIds: followeeIds }
      case 'department':
        return { followeeDepartmentIds: followeeIds }
      case 'user':
        return { followeeUserIds: followeeIds }
    }
  })()

  return {
    followAll: () => batchFollow({ variables }),
    loading: loading,
  }
}
